import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Text } from "../../types/text";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  EntityWithMetadataTableSuffixColumns,
  createEntityFilterSpec,
  publishedIdColumn,
  withFieldProofreadingIndicator,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import {
  formatLinksList,
  LinksList,
} from "../../components/forms/common/subForms/LinksListField";

const columnHelper = createMRTColumnHelper<Text>();

export const textColumns: MRT_ColumnDef<Text, any>[] = [
  publishedIdColumn,
  columnHelper.accessor("name", {
    header: "Name",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),

  columnHelper.accessor("sources", {
    header: "Sources",
    Cell: ({ cell }) => {
      const sources = (cell.getValue() as LinksList) || [];
      return formatLinksList(sources);
    },
  }),

  columnHelper.accessor("version", {
    header: "Version",
    enableColumnFilter: false,
    Cell: ({ cell }) => <EntityReferenceComponent entity={cell.getValue()} />,
  }),

  columnHelper.accessor("digitization", {
    header: "Digitization",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),

  columnHelper.accessor("text", {
    header: "Text Names",
    Cell: ({ cell }) => (cell.getValue() || []).join(", "),
  }),

  columnHelper.accessor("based_on_type", {
    header: "Based On",
    Cell: withFieldProofreadingIndicator("based_on_type", ({ cell }) =>
      cell.getValue() || "-"
    ),
  }),

  ...EntityWithMetadataTableSuffixColumns,
];

export const textFilterSpec: FilterSpec = createEntityFilterSpec({
  name: { kind: "string" },
  sources: { kind: "string" },
  digitization: { kind: "string" },
  text: { kind: "string" },
  based_on_type: { kind: "string" },
});

export default textColumns;
